// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__33dsM","label":"SetPasswdForm_label__1Wez8"};